'use strict';

import getNgModule from "getNgModule";
import moment from "moment";
var ngModule = getNgModule(__filename);
ngModule.directive("marketdataIcePage", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./marketdataIcePage.html"),
    controller: function controller($scope, $http, $translate, chartUtils, lovService, indexationService, $q, $numberFormat, $dateFormat) {
      var MIN_DATE = moment("20230901", "YYYYMMDD").toDate();
      var MAX_DATE = moment().toDate();
      $scope.params = {
        dateMarche: moment().toDate(),
        index: 'EUR3M',
        typeVol: 'LOG_NORMAL'
      };
      $scope.typeVolatilites = [{
        id: 'LOG_NORMAL',
        label: 'LOG NORMAL'
      }, {
        id: 'NORMAL',
        label: 'NORMAL'
      }];
      $scope.indices = _.map(["EUR1M", "EUR3M", "EUR6M", "EUR12M"], indexationService.getIndice);
      $scope.getData = function () {
        $scope.loading = true;
        $http.get("/rest/analyse/marketdata-pricer-option/donnees-courbe-taux", {
          params: $scope.params
        }).then(function (response) {
          $scope.ycData = response.data;
        }).finally(function () {
          $scope.loading = false;
        });
        $http.get("/rest/analyse/marketdata-pricer-option/donnees-volatilite", {
          params: $scope.params
        }).then(function (response) {
          $scope.matrice = response.data;
          $scope.volData = $scope.matrice.tenorVolatilities;
          var columns = [{
            attribute: 'tenor',
            title: 'tenor',
            cellClass: 'align-c',
            sortable: true,
            sortType: 'number'
          }];
          var minStrike = $scope.matrice.minStrike;
          var nbStrikes = $scope.volData[0].vol.length;
          for (var strike = 0; strike < nbStrikes; strike++) {
            columns.push({
              attribute: 'vol[' + strike + ']',
              title: '' + (minStrike + strike * 0.25) + "%",
              cellClass: 'align-c'
            });
          }
          $scope.volTableConfig = {
            source: "volData",
            allowSelection: true,
            selectionAttribute: "selectedVolData",
            selectionScope: $scope,
            footer: 'static',
            columns: columns
          };
          $http.get("/rest/analyse/marketdata-pricer-option/courbes-taux", {
            params: $scope.params
          }).then(function (response) {
            $scope.courbesTauxData = response.data;
            $scope.courbesTauxChartConfig.series = [{
              name: 'Courbe taux ICAP ' + $scope.params.index + ' (données du ' + $dateFormat.date($scope.courbesTauxData.dateCourbeICAP) + ')',
              data: chartUtils.mapAndFilter($scope.courbesTauxData.courbeICAP, "date", "valeur"),
              color: '#15a3ef'
            }, {
              name: 'Courbe taux Taelys' + ' (données du ' + $dateFormat.date($scope.courbesTauxData.dateCourbeTaelys) + ')',
              data: chartUtils.mapAndFilter($scope.courbesTauxData.courbeTaelys, "date", "valeur"),
              color: '#4daf19'
            }];
          }).finally(function () {
            $scope.loading = false;
          });
          $http.get("/rest/analyse/marketdata-pricer-option/courbes-anticipes", {
            params: $scope.params
          }).then(function (response) {
            $scope.courbesAnticipesData = response.data;
            $scope.courbesAnticipesChartConfig.series = [{
              name: 'Courbe taux ICAP ' + $scope.params.index,
              data: chartUtils.mapAndFilter($scope.courbesAnticipesData.courbeICAP, "date", "valeur"),
              color: '#15a3ef'
            }, {
              name: 'Courbe taux Taelys',
              data: chartUtils.mapAndFilter($scope.courbesAnticipesData.courbeTaelys, "date", "valeur"),
              color: '#4daf19'
            }, {
              name: 'Spread',
              data: chartUtils.mapAndFilter($scope.courbesAnticipesData.spread, "date", "valeur"),
              color: '#F77600'
            }];
          }).finally(function () {
            $scope.loading = false;
          });
        }).finally(function () {
          $scope.loading = false;
        });
      };
      $scope.$watch("params", function () {
        if ($scope.params.dateMarche < MIN_DATE) {
          $scope.params.dateMarche = MIN_DATE;
        }
        if ($scope.params.dateMarche > MAX_DATE) {
          $scope.params.dateMarche = MAX_DATE;
        }
        $scope.getData();
      }, true);
      $scope.ycDataTableConfig = {
        source: "ycData",
        allowSelection: true,
        selectionAttribute: "selectedYcData",
        selectionScope: $scope,
        footer: 'static',
        columns: [{
          attribute: 'id',
          title: 'id',
          cellClass: 'align-c',
          sortType: "date",
          sortable: true
        }, {
          attribute: 'fixing.dateValeur',
          title: 'dateValeur',
          filter: 'dateShort',
          cellClass: 'align-c',
          sortType: "date",
          sortable: true
        }, {
          attribute: 'fixing.valeur',
          title: 'Fixing',
          cellClass: 'align-c',
          filter: 'percentage:5'
        }]
      };
      $scope.courbesTauxChartConfig = {
        options: {
          chart: {
            type: 'line',
            height: '300',
            zoomType: "x"
          },
          legend: {
            enabled: false
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var tooltip = '<span>' + $dateFormat.date(this.x) + '</span> :  <br/>';
              _.each(this.points, function (point) {
                var value = $numberFormat.percentage(point.y, 3);
                var label = point.series.name;
                var serieLine = '<span style="color: ' + point.series.color + '; font-weight: bold;">' + label + '</span> : ' + value;
                tooltip += serieLine + "<br/>";
              });
              return tooltip;
            }
          },
          xAxis: {
            type: 'datetime',
            tickInterval: 1000 * 60 * 60 * 24 * 365
          },
          yAxis: {
            title: {
              text: 'Taux'
            },
            labels: {
              formatter: function formatter() {
                return $numberFormat.percentage(this.value, 2);
              }
            }
          }
        }
      };
      $scope.courbesAnticipesChartConfig = {
        options: {
          chart: {
            type: 'line',
            height: '300',
            zoomType: "x"
          },
          legend: {
            enabled: false
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var tooltip = '<span>' + $dateFormat.date(this.x) + '</span> :  <br/>';
              _.each(this.points, function (point) {
                var value = $numberFormat.percentage(point.y, 3);
                var label = point.series.name;
                var serieLine = '<span style="color: ' + point.series.color + '; font-weight: bold;">' + label + '</span> : ' + value;
                tooltip += serieLine + "<br/>";
              });
              return tooltip;
            }
          },
          xAxis: {
            type: 'datetime',
            tickInterval: 1000 * 60 * 60 * 24 * 365
          },
          yAxis: {
            title: {
              text: 'Taux'
            },
            labels: {
              formatter: function formatter() {
                return $numberFormat.percentage(this.value, 2);
              }
            }
          }
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/ice/marketdataIcePage.js
// module id = 2850
// module chunks = 13